module.exports = __webpack_public_path__ + "img/down.b32efa69.svg";